import ClockNoPaddingIcon from '@shared/assets/icons/v2/clock-no-padding.svg';
import { MBView } from '@shared/components/MBView';
import { Text } from '@shared/components/Text';
import { MBIcon } from '@shared/components/image';
import { Styles } from './styles';

interface MBUrgentBadgeProps {
  /*
        What direction should the badge "float" to?
    */
  align: 'left' | 'right';
}

export function MBUrgentBadge({ align }: MBUrgentBadgeProps) {
  return (
    <MBView
      row
      center
      wrap
      style={[Styles.urgentBadge, align === 'right' && Styles.urgentBadgeAlignRight]}
    >
      <MBIcon noPadding color="white" style={Styles.urgentIcon} source={ClockNoPaddingIcon} />
      <Text color="white" size="caption2" style={{ marginInline: '4px' }}>
        Urgent
      </Text>
    </MBView>
  );
}
